import type { Components, Theme } from "@mui/material/styles";

export const MuiListItemText: Components<Theme>["MuiListItemText"] = {
  styleOverrides: {
    primary: {
      fontSize: 15,
      color: "black",
      fontWeight: 500,
    },
    secondary: ({ theme }) => ({
      color: theme.palette.divider,
      fontSize: theme.spacing(2),
      fontWeight: 600,
    }),
    // multiline applied when both primary and secondary are set
    multiline: {
      "& span": {
        marginBottom: 5,
      },
    },
  },
};
